import React from 'react';
import PropTypes from 'prop-types';

import { Link as MUILink } from '@mui/material';

export const Link = props => <MUILink {...props} />;

Link.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object,
  color: PropTypes.oneOf(['initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error']),
  component: PropTypes.elementType,
  href: PropTypes.string,
  underline: PropTypes.oneOf(['none', 'hover', 'always']),
  variant: PropTypes.string
};

export default Link;
